import React, { useEffect, useRef } from 'react';
import { Button } from '../ui/Button';
export function Hero() {
  const imgRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    // Ensure fetchpriority is set as HTML attribute
    if (imgRef.current) {
      imgRef.current.setAttribute('fetchpriority', 'high');
    }
  }, []);
  return <section className="bg-sky-100 text-gray-900 pt-6 pb-10 px-4" data-id="element-53">
      <div className="max-w-5xl mx-auto text-center" data-id="element-54">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold mb-2 leading-tight text-gray-900 uppercase" data-id="element-55">
          LOGRÁ QUE TU BEBÉ DUERMA HASTA 6 HORAS SEGUIDAS SIN DEJARLO LLORAR
        </h1>

        <p className="text-lg md:text-2xl text-gray-600 mb-5 font-medium" data-id="element-56">
          Sin métodos invasivos y sin romper el vínculo.
        </p>

        <div className="bg-yellow-100 rounded-lg px-5 py-3 mb-5 border border-yellow-300 max-w-2xl mx-auto" data-id="element-57">
          <p className="text-base md:text-lg text-gray-800 font-semibold" data-id="element-58">
            Para mamás y papás de bebés de 0 a 24 meses que están agotados y
            necesitan una solución real.
          </p>
        </div>

        <div className="mb-5 mx-auto w-[280px] h-[280px] md:w-[320px] md:h-[320px]" data-id="element-59">
          <img ref={imgRef} src="https://cdn.magicpatterns.com/uploads/7JqcfQigPgCUz8cnpAX8jJ/mockup_final_dormir_mejor_desde_el_amor.png" alt="MegaPack Dormir Mejor Desde el Amor" width={320} height={320} loading="eager" decoding="sync" fetchPriority="high" className="w-full h-full object-contain" data-id="element-60" />
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 text-base md:text-lg font-semibold text-gray-800 mb-5" data-id="element-61">
          <span data-id="element-62">✔ Sin culpa</span>
          <span className="hidden md:inline text-gray-400" data-id="element-63">•</span>
          <span data-id="element-64">✔ Sin "entrenamiento"</span>
          <span className="hidden md:inline text-gray-400" data-id="element-65">•</span>
          <span data-id="element-66">✔ Basado en ciencia y apego</span>
        </div>

        <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="xl" className="w-full md:w-auto text-xl md:text-2xl" data-id="element-67">
          👉 SÍ, QUIERO QUE MI BEBÉ DUERMA MEJOR DESDE HOY
        </Button>

        <p className="mt-3 text-sm text-gray-600 flex items-center justify-center gap-2 font-medium" data-id="element-68">
          🔒 Garantía de satisfacción de 7 días
        </p>
      </div>
    </section>;
}